import { render, staticRenderFns } from "./flashsale.vue?vue&type=template&id=945168c4&scoped=true&"
import script from "./flashsale.vue?vue&type=script&lang=ts&"
export * from "./flashsale.vue?vue&type=script&lang=ts&"
import style0 from "./flashsale.vue?vue&type=style&index=0&id=945168c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945168c4",
  null
  
)

export default component.exports